// extracted by mini-css-extract-plugin
export var askAiIcon = "_ni-9";
export var container = "_ni-0";
export var groupSeparator = "_ni-a";
export var highlight = "_ni-4";
export var resultIcon = "_ni-5";
export var resultItem = "_ni-7";
export var resultSubtitle = "_ni-3";
export var resultTitle = "_ni-2";
export var resultsList = "_ni-1";
export var searchGroup = "_ni-6";
export var selected = "_ni-8";